import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

/**
 * Reusable FAQ block using shadcn Accordion.
 * Pass items as { q, a } objects.
 */
export default function FAQ({ items = [], testIdPrefix = "faq" }) {
  return (
    <Accordion type="single" collapsible className="w-full" data-testid={`${testIdPrefix}-accordion`}>
      {items.map((item, i) => (
        <AccordionItem
          key={item.q}
          value={`item-${i}`}
          className="border-b border-white/[0.06] last:border-b-0"
          data-testid={`${testIdPrefix}-item-${i}`}
        >
          <AccordionTrigger className="text-left text-base md:text-lg font-display font-light tracking-tight text-white py-6 hover:no-underline hover:text-gold transition-colors [&[data-state=open]]:text-gold">
            {item.q}
          </AccordionTrigger>
          <AccordionContent className="text-zinc-400 leading-relaxed text-[15px] pb-6 pr-8">
            {item.a}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
